export const taskKeys = {
  listAll: (
    machineId?: string | null,
    workOrderOperationNId?: string | null,
    workOrderNId?: string | null,
    materialUId?: string | null
  ) =>
    [
      "tasks",
      machineId,
      workOrderOperationNId,
      workOrderNId,
      materialUId,
    ] as const,
  getParameter: (param: string, taskId?: string | null) =>
    ["taskParameter", param, taskId] as const,
  getProductsWaitingForValidation: (
    machineId?: string | null,
    mtuCode?: string | null
  ) => ["productsWaitingForValidation", machineId, mtuCode] as const,
};
